import { createAction } from 'redux-actions';

export const NAMES = {
  SET: 'CLIENT.VIDEO.OVERLAY_CONTENT.SET',
};

export const setOverlayContent = createAction(NAMES.SET);
